import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'

import { inject, observer } from 'mobx-react'

import { Section, SectionHeading } from '../marketing/MarketingStyles';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

@inject('golfCourseStore')
@observer
class GolfCourseList extends Component {

  componentDidMount() {
    this.props.golfCourseStore.getGolfCourses()
  }

  addCourseLink = (cell, row) => {
    return (<div><a href={cell} target="_blank" style={{cursor: "pointer"}}>{cell}</a></div>);
  }

  render() {

    let courses = this.props.golfCourseStore.golfCourses
    courses = courses && courses.map(item => {
      return { ...item, region: item.region ? item.region.title : '' }
    })

    return (
      <Section>
        <GolfCourseTableWrapper>
          <BootstrapTable data={ courses } borderless options={{ defaultSortName: 'courseName', defaultSortOrder: 'desc' }}>
            <TableHeaderColumn dataField="courseName" isKey>
              <SectionHeading>Name</SectionHeading>
            </TableHeaderColumn>
            <TableHeaderColumn dataField="region">
              <SectionHeading>Bundesland</SectionHeading>
            </TableHeaderColumn>
            <TableHeaderColumn dataField="address">
              <SectionHeading>Adresse</SectionHeading>
            </TableHeaderColumn>
            {/* <TableHeaderColumn dataField="hole_count">
              <SectionHeading>Anzahl der Löcher</SectionHeading>
            </TableHeaderColumn> */}
            <TableHeaderColumn dataField="website" dataFormat={ this.addCourseLink }>
              <SectionHeading>Website</SectionHeading>
            </TableHeaderColumn>
          </BootstrapTable>
        </GolfCourseTableWrapper>
      </Section>
    )
  }
}

export default GolfCourseList

const GolfCourseTableWrapper = styled.div `

  display: block;

  font-family: 'Supreme-Regular';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;

  thead tr th {
    color: ${ cssVar.colors.blue };
    border: none !important;
  }

  tbody tr td {
    border: none !important;
  }

  tbody tr:nth-child(2n + 1) {
    background: ${ cssVar.colors.lightest_grey }
  }

  ${cssVar.breakpoints.tablet} {
    overflow-x: auto;
    td, th {
      width: 200px;
    }
  }
`



// WEBPACK FOOTER //
// /src/components/marketing/GolfCourseList.js